import BaseService from "../BaseService";
import _ from "lodash";

class StoreSettingService extends BaseService {
    getPublicStoreSetting = async ({ shopCode } = {}) => {
        var data = await this._api.get("/store/store_setting/getstoresetting", {
            headers: {
                w_id: shopCode,
                w_url: shopCode,
            }
        });
        return data;
    };

    getWebsiteSetting = async () => {
        var data = await this._api.get("/store_setting/getwebsitesetting");
        return data;
    };
    saveWebSiteSetting = async (setting) => {
        var data = await this._api.post("/store_setting/saveWebsiteSetting", setting);
        return data;
    };

    getBankTranfer = async () => {
        var data = await this._api.get("/store_setting/getbanktranfer");
        return data;
    };
    saveBankTranfer = async (setting) => {
        var data = await this._api.post("/store_setting/savebanktranfer", setting);
        return data;
    };

    saveBankTranferWithOTP = async (setting) => {
        var data = await this._api.post("/store_setting/savebanktranferwithotp", setting);
        return data;
    };



    getPrintSetting = async () => {
        var data = await this._api.get("/store_setting/getprintsetting");
        return data;
    };
    getDefaultPrintSetting = async () => {
        var data = await this._api.get("/store_setting/getdefaultprintsetting");
        return data;
    };
    savePrintSetting = async (setting) => {
        var data = await this._api.post("/store_setting/saveprintsetting", setting);
        return data;
    };


    getOrderSetting = async () => {
        var data = await this._api.get("/store_setting/getordersetting");
        return data;
    };

    saveOrderSetting = async (setting) => {
        var data = await this._api.post("/store_setting/saveordersetting", setting);
        return data;
    };

    getInventoryDeductionSetting = async () => {
        var data = await this._api.get("/store_setting/getinventorydeductionsetting");
        return data;
    };

    saveInventoryDeductionSetting = async (setting) => {
        var data = await this._api.post("/store_setting/saveinventorydeductionsetting", setting);
        return data;
    };

    getOrderInternalStatuses = async () => {
        var data = await this._api.get("/store_setting/getorderinternalstatuses");
        return data;
    };

    saveOrderInternalStatuses = async (statuses) => {
        var data = await this._api.post("/store_setting/saveorderinternalstatuses", { statuses });
        return data;
    };



    checkSiteUrl = async (url) => {
        var data = await this._api.post("/store_setting/checksiteurl", { url });
        return data;
    };



    getHomePageSetting = async () => {
        var data = await this._api.get("/store_setting/gethomepagesetting");
        return data;
    };
    saveHomePageSetting = async (setting) => {
        var data = await this._api.post("/store_setting/savehomepagesetting", setting);
        return data;
    };

    getCollaboratorSetting = async () => {
        var data = await this._api.get("/store_setting/getcollaboratorsetting");
        return data;
    };
    saveCollaboratorSetting = async (setting) => {
        var data = await this._api.post("/store_setting/savecollaboratorsetting", setting);
        return data;
    };


    getShippingfeeSetting = async () => {
        var data = await this._api.get("/store_setting/getshippingfeesetting");
        return data;
    };
    saveShippingfeeSetting = async (setting) => {
        var data = await this._api.post("/store_setting/sveshippingfeesetting", setting);
        return data;
    };

    getScriptSetting = async () => {
        var data = await this._api.get("/store_setting/getscriptsetting");
        return data;
    };

    saveScriptSetting = async (setting) => {
        var data = await this._api.post("/store_setting/savescriptsetting", setting);
        return data;
    };

    getSEOBrandProfile = async () => {
        var data = await this._api.get("/store_seo/getseobrandprofile");
        return data;
    };

    saveSEOBrandProfile = async (setting) => {
        var data = await this._api.post("/store_seo/saveseobrandprofile", setting);
        return data;
    };

    getSEORuntimeSetting = async () => {
        var data = await this._api.get("/store_seo/getseoruntimesetting");
        return data;
    };

    saveSEORuntimeSetting = async (setting) => {
        var data = await this._api.post("/store_seo/saveseoruntimesetting", setting);
        return data;
    };

    getSEOSocialShareSetting = async () => {
        var data = await this._api.get("/store_seo/getseosocialsharesetting");
        return data;
    };

    saveSEOSocialShareSetting = async (setting) => {
        var data = await this._api.post("/store_seo/saveseosocialsharesetting", setting);
        return data;
    };

    getSEOLandingPages = async ({ status = "", keyword = "", page = 1, page_size = 20 } = {}) => {
        var data = await this._api.get("/store_seo/getseolandingpages", {
            params: { status, keyword, page, page_size },
        });
        return data;
    };

    getSEOLandingPage = async ({ id = "", slug = "" } = {}) => {
        var data = await this._api.get("/store_seo/getseolandingpage", {
            params: { id, slug },
        });
        return data;
    };

    saveSEOLandingPage = async (payload) => {
        var data = await this._api.post("/store_seo/saveseolandingpage", payload);
        return data;
    };

    publishSEOLandingPage = async ({ id = "", slug = "" } = {}) => {
        var data = await this._api.post("/store_seo/publishseolandingpage", { id, slug });
        return data;
    };

    unpublishSEOLandingPage = async ({ id = "", slug = "" } = {}) => {
        var data = await this._api.post("/store_seo/unpublishseolandingpage", { id, slug });
        return data;
    };

    deleteSEOLandingPage = async ({ id = "" } = {}) => {
        var data = await this._api.post("/store_seo/deleteseolandingpage", { id });
        return data;
    };

    getSEOFeedStatus = async () => {
        var data = await this._api.get("/store_seo/getseofeedstatus");
        return data;
    };

    pingSEOShopSitemap = async () => {
        var data = await this._api.post("/store_seo/pingseoshopsitemap", {});
        return data;
    };

    createSEOShopSitemap = async () => {
        var data = await this._api.post("/store_seo/createseoshopsitemap", {});
        return data;
    };

    generateSEOBrandProfileAI = async (payload = {}) => {
        var data = await this._api.post("/store_seo/generateseobrandprofileai", payload);
        return data;
    };

    generateSEOLandingAI = async (payload = {}) => {
        var data = await this._api.post("/store_seo/generateseolandingai", payload);
        return data;
    };

    generateSEOLandingMetaAI = async (payload = {}) => {
        var data = await this._api.post("/store_seo/generateseolandingmetaai", payload);
        return data;
    };

    generateSEOLandingHTMLAI = async (payload = {}) => {
        var data = await this._api.post("/store_seo/generateseolandinghtmlai", payload);
        return data;
    };














    // update = async ({ id, name }) => {
    //     var data = await this._api.post(`/product_tag/update`, { id, name });
    //     return data;
    // };

    // create = async ({ name }) => {
    //     var data = await this._api.post(`/product_tag/create`, { name });
    //     return data;
    // };


    // get = async (id) => {
    //     var data = await this._api.get(`/product_tag/get`, { params: { id: id } });
    //     return data;
    // };


    // delete = async (id) => {
    //     var data = await this._api.post(`/product_tag/delete`, { id: id });
    //     return data;
    // };



}
export default StoreSettingService;
